<template>
	<div>
		<v-form>
			<v-text-field label="Name" v-model="section.title"></v-text-field>
			<tiptap-vuetify
				class="text-left"
				v-model="section.content"
				:extensions="extensions"
			/>
		</v-form>

		<div class="action-wrapper">
			<v-speed-dial
				v-model="fab"
				bottom
				right
				direction="left"
				transition="slide-y-reverse-transition">
				<template v-slot:activator>
					<v-btn
						v-model="fab"
						color="blue darken-2"
						dark
						fab>
						<v-icon v-if="fab">mdi-close</v-icon>
						<v-icon v-else>mdi-pencil</v-icon>
					</v-btn>
				</template>
				<v-btn
					fab
					dark
					small
					@click="sectionSave"
					color="green">
					<v-icon>mdi-content-save</v-icon>
				</v-btn>
				<v-btn
					fab
					dark
					small
					@click="sectionDelete"
					color="red">
					<v-icon>mdi-delete</v-icon>
				</v-btn>
			</v-speed-dial>
		</div>
	</div>
</template>

<script>
	import {
		Heading,
		Bold,
		BulletList,
		History,
		HorizontalRule,
		Italic,
		Link,
		ListItem,
		OrderedList,
		Paragraph,
		Strike,
		TiptapVuetify,
		Underline,
		HardBreak
	} from 'tiptap-vuetify';
	import { db } from './../../db';
	const sections = db.collection('sections');

	export default {
		props: ['id'],
		components: {TiptapVuetify},
		data: () => ({
			extensions: [
				[Heading, {
					options: {
						levels: [1, 2, 3, 4]
					}
				}],
				Underline,
				Strike,
				Italic,
				Bold,
				Link,
				ListItem,
				BulletList,
				OrderedList,
				HorizontalRule,
				Paragraph,
				History,
				HardBreak
			],
			fab: false,
			section: {
				title: '',
				content: '',
				uuid: ''
			}
		}),
		methods: {
			sectionSave() {
				if (this.section.uuid && this.section.uuid.length) {
					this.section.updateDate = Date.now();

					this.$firestoreRefs.section.update(this.section).then(() => {
						this.$notify({
							group: 'system',
							type: 'success',
							title: 'Great!',
							text: 'Section has been updated!'
						});
					})
				} else {
					this.section.uuid = this.$uuid.v1();
					sections.add(this.section).then(() => {
						this.$notify({
							group: 'system',
							type: 'success',
							title: 'Great!',
							text: 'Section has been created!'
						});
						this.$router.push({name: 'sectionsList'});
					})
				}
			},
			sectionDelete() {
				this.$firestoreRefs.section.delete().then(() => {
					this.$router.push({name: 'sectionsList'});
					this.$notify({
						group: 'system',
						type: 'success',
						title: 'Great!',
						text: 'Section has been removed!'
					});
				})
			},
		},
		watch: {
			id: {
				immediate: true,
				handler(id) {
					if (id.toString() !== '0') this.$bind('section', sections.doc(id))
				},
			},
		}
	}
</script>

<style lang="scss">
	.tiptap-vuetify-editor__content {
		max-height: 60vh;
		p{
			margin: 0 0 15px!important;
		}
	}
	.tiptap-vuetify-editor .ProseMirror{
		height: 100%!important;
	}
</style>
